
import './IgongChartSchoolList.scss';
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';
import React, { useState, useEffect } from 'react';
import { Button, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const IgongChartSchoolList = ({data}) => {

    const [list, setList] = useState([]);
    const [selectedSno, setSelectedSno] = useState(null);
  
    useEffect(() => {
        if (data.length > 0) {
            fncSelect_list(data[0].cntA, data[0].cntB ,data[0].cntE, data[0].cntF);
        }
    }, []);
        
    function fncSelect_list(A, B ,E, F) {
        fnc.sendAxios('/igongAssess_chart/detail/select/schoolList', { A, B ,E, F }, (res) => {
            if (res && Array.isArray(res)) {
                const newList = getRecords(res);
                setList(newList);
            } else {
            alert('검색에 실패했습니다(schoolList)');
            }
        });

        function getRecords(res) {
            const records = [];
            res.forEach(item => {
            const sno = item["no"];
            const school = item["school"];
            const department_track = item["department_track"];//계열
            const admission_unit = item["admission_unit"];//모집단위
            records.push({ sno, school, department_track, admission_unit });
            });
            return records;
        }

    }
    
  
    
  function onClickTr( item, index) {

  }



//=========================================
  return (
    <div className='IgongChartSchoolList'>
        <div className='title'>전공적합 진로계열관련 전국 주요대학 전공리스트</div>
        
        <section className='sec-main'>
          <table className="table-hong table-main">
            <thead>
                <tr>
                <th>No</th>
                <th>학교</th>
                <th>계열</th>
                <th>모집단위</th>     
                </tr>
            </thead>

            <tbody>
                {list && list.map((item, index) => (
                    <tr key={index} onClick={() => onClickTr(item, index)}
                        className={selectedSno === item.sno ? 'selected' : ''}>  
                        <td>{index+1}</td>
                        <td>{item.school}</td>
                        <td>{item.department_track}</td>
                        <td>{item.admission_unit}</td>  
                    </tr>
                ))}
            
                </tbody>

            </table>

          </section>

    </div>
  );
};

export default IgongChartSchoolList;